import { IBrandSearchQueryUXMessaging } from "@faire/web-api--source/indigofair/data/IBrandSearchQueryUXMessaging";
import { ILeanProductTile } from "@faire/web-api--source/indigofair/data/ILeanProductTile";
import React from "react";

interface IBrandSearchContext {
  brand: ILeanProductTile.IBrand | undefined;
  brandPagePath: string;
  handleBrandClick: (identifier: string | undefined) => () => void;
  products?: ILeanProductTile[];
  requestId?: string;
  searchString?: string;
  insiderMessage?: IBrandSearchQueryUXMessaging;
}

export const BrandSearchContext = React.createContext<IBrandSearchContext>({
  brand: undefined,
  brandPagePath: "",
  handleBrandClick: () => () => {},
});
